import { create } from 'zustand';

export type BulkSection = 'queues' | 'services' | 'nodes' | 'jobs';

interface BulkState {
  selections: Record<BulkSection, Set<string>>;
  toggle: (section: BulkSection, id: string) => void;
  clear: (section: BulkSection) => void;
  setAll: (section: BulkSection, ids: string[]) => void;
  clearAll: () => void;
}

function emptySelections(): Record<BulkSection, Set<string>> {
  return {
    queues: new Set<string>(),
    services: new Set<string>(),
    nodes: new Set<string>(),
    jobs: new Set<string>(),
  };
}

export const useBulkStore = create<BulkState>(set => ({
  selections: emptySelections(),
  toggle: (section, id) =>
    set(state => {
      const next = new Set(state.selections[section]);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return { selections: { ...state.selections, [section]: next } };
    }),
  clear: section =>
    set(state => ({
      selections: { ...state.selections, [section]: new Set<string>() },
    })),
  setAll: (section, ids) =>
    set(state => ({
      selections: { ...state.selections, [section]: new Set(ids) },
    })),
  clearAll: () => set({ selections: emptySelections() }),
}));

export const bulkStore = useBulkStore;
